// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import { getDatabase } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCIqd4ceJlfRE0hmPtzwmtc3Cfw0cWbdvI",
  authDomain: "motobookie-payemnt-portal.firebaseapp.com",
  projectId: "motobookie-payemnt-portal",
  storageBucket: "motobookie-payemnt-portal.appspot.com",
  messagingSenderId: "305593932601",
  appId: "1:305593932601:web:7be0c0b3d9e5d2043626e8",
  measurementId: "G-4KY1Z656S8"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const database = getDatabase(app);
